import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ReviewCycleListItemFragment = { id: string, createdAt: string, updatedAt: string, title: string, startDate?: string | null, endDate?: string | null, status: Types.ReviewCycleStatusEnum, type: Types.ReviewCycleTypeEnum, completionPercentage?: number | null, createdBy?: { id: string, name?: string | null } | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null, reviewCycleEndSettings?: { cycleEndType: Types.ReviewCycleEndTypeEnum } | null, scheduleSettings?: { scheduleType: Types.ReviewCycleScheduleTypeEnum, recurringType?: Types.ReviewCycleRecurringTypeEnum | null } | null };


export type ReviewCycleListItemFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ReviewCycleListItemFragmentDoc = /*#__PURE__*/ gql`
    fragment ReviewCycleListItem on ReviewCycleType {
  id
  createdAt
  updatedAt
  createdBy {
    id
    name
  }
  title
  iconSettings {
    type
    value
  }
  startDate
  endDate
  status
  type
  completionPercentage
  reviewCycleEndSettings {
    cycleEndType
  }
  scheduleSettings {
    scheduleType
    recurringType
  }
}
    `;